/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

// Copied from otc-api: https://github.ibm.com/org-ids/otc-api/blob/master/app/helpers/crn.js
var requireServer = require('./require-server'),
  nconf = requireServer('nconf');

/**
* Builds a correctly formatted CRN based on the defined structure:
* crn:v1:{cname}:{ctype}:{service-name}:{location}:a/{IBM-account}:{service-instance}:{resource-type}:{resource}
*
* {String} cname - The Cloud instance, e.g. staging or public.
* @param {String} serviceName - The unique identifier of the service, e.g. continuous-delivery or toolchain.
* @param {String} location - The region where the resource resides, e.g. us-south.
* @param {String} accountId - The user's Account ID where the resource is created.
* @param {String} serviceInstance - The service instance, e.g. toolchain_guid.
* @param {String} resourceType - The sub-resource type, e.g. service-binding (optional).
* @param {String} resource - The sub-resource ID, e.g. service_id (optional).
**/
var buildCRN = function buildCRN(serviceName, location, accountId, serviceInstance, resourceType, resource) {
  var crn = "crn:v1:".concat(nconf.get('toolchainResourceControllerCname'), ":public:").concat(serviceName, ":").concat(location, ":a/").concat(accountId, ":").concat(serviceInstance, ":");
  if (resourceType && resource) {
    crn += "".concat(resourceType, ":").concat(resource);
  } else {
    crn += ':';
  }
  return crn;
};

/**
* Convert the MCCP region (e.g. ibm:yp:us-south) to a location (e.g. us-south).
*
* @param {String} region - The region to convert.
**/
var convertRegionToLocation = function convertRegionToLocation(region) {
  return region.substr(region.lastIndexOf(':') + 1);
};

/**
* Decomposes a CRN into its parts from the defined structure:
* crn:v1:{cname}:{ctype}:{service-name}:{location}:a/{IBM-account}:{service-instance}:{resource-type}:{resource}
*
* @param {String} crn - The crn to decompose.
**/
var decomposeCRN = function decomposeCRN(crn) {
  var crnParts = crn.split(':');

  // Remove the 'a/' segment.
  var accountId = crnParts[6];
  if (accountId) {
    accountId = accountId.split('/')[1];
  }
  return {
    cname: crnParts[2],
    ctype: crnParts[3],
    serviceName: crnParts[4],
    location: crnParts[5],
    accountId: accountId,
    serviceInstance: crnParts[7],
    resourceType: crnParts[8],
    resource: crnParts[9]
  };
};
module.exports.buildCRN = buildCRN;
module.exports.convertRegionToLocation = convertRegionToLocation;
module.exports.decomposeCRN = decomposeCRN;